import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    HostBinding,
    HostListener,
    Injector,
    OnDestroy,
    Output,
    Type,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {DialogStackService} from '../../../services/utils/dialog-stack.service';

@Component({
    selector: 'app-popup-overlay',
    templateUrl: './popup-overlay.component.html',
    styleUrls: ['./popup-overlay.component.scss'],
    standalone: false
})
export class PopupOverlayComponent implements OnDestroy, AfterViewInit {

    data: any;
    styleHidden = false;
    component?: Type<any>;

    @ViewChild('dynamicComponent', { read: ViewContainerRef }) dynamicContainer?: ViewContainerRef;
    @Output() closeModal = new EventEmitter<any>();

    private modalClose$: Subject<boolean> = new Subject();

    @HostListener('document:keydown.escape', ['$event'])
    onEsc(event: KeyboardEvent) {
        // When popups are stacked, ESC must close only the topmost one.
        if (!this.dialogStack.isTopmost(this)) {
            return;
        }
        this.modalClose$.next(false);
    }

    @HostBinding('style.display')
    get display() {
        return this.styleHidden ? 'none' : 'block';
    }

    constructor(
        private cdRef: ChangeDetectorRef,
        private readonly dialogStack: DialogStackService
    ) {
    }

    public ngAfterViewInit(): void {
        this.dialogStack.register(this);
        if (this.dynamicContainer && this.component) {
            const injector = Injector.create({
                providers: [
                    { provide: 'DATA', useValue: this.data }
                ]
            });
            const componentRef = this.dynamicContainer.createComponent(this.component, { injector });
            this.cdRef.detectChanges();
            componentRef.instance.parent = this;

            // If the component has a show method, call it
            if (componentRef.instance.show && typeof componentRef.instance.show === 'function') {
                console.log('Calling show method on component instance');
                setTimeout(() => {
                    componentRef.instance.show();
                }, 0);
            }
        }
    }

    ngOnDestroy(): void {
        this.dialogStack.unregister(this);
        setTimeout(() => {
            this.modalClose$.complete();
        }, 0);
    }

    public onModalClose(): Observable<boolean> {
        return this.modalClose$.asObservable();
    }

    closePopup(event: any): void {
        if (event && event.target && event.target.id === 'outline-popup-box') {
            this.modalClose$.next(false);
        }
    }

    emitCloseRes(data: any): void {
        this.modalClose$.next(data);
    }

    styleHide(): void {
        this.styleHidden = true;
    }

    styleShow(): void {
        this.styleHidden = false;
    }

    styleToggle(): void {
        this.styleHidden = !this.styleHidden;
    }

}
